module.exports = __webpack_public_path__ + "img/icon_point2-8.c30fb4af.svg";